import { useAppContext } from '../../context/AppContext';
import { domainForHunt, formatLabel } from '../../lib/huntDomain';
import GridCell from './GridCell';
import styles from './MainGrid.module.css';

export default function MainGrid({ layers }) {
  const { state, dispatch, derived, activeHunt } = useAppContext();
  const { photosByItem, primaryByItem, capturedItems, sharedLocations } = derived;
  const { activeFilter } = state;

  if (!activeHunt) return null;

  const huntList = activeHunt.huntList ?? [];
  const domain = domainForHunt(activeHunt, [...photosByItem.values()].flat());
  const isCustom = activeHunt.type === 'custom';

  function isCellVisible(itemKey) {
    if (activeFilter === 'missing') return !capturedItems.has(itemKey);
    if (activeFilter === 'found')   return capturedItems.has(itemKey);
    return true;
  }

  function handleCellClick(itemKey) {
    const photos = photosByItem.get(itemKey) ?? [];
    if (photos.length === 0) {
      dispatch({ type: 'OPEN_MODAL', modal: 'addPhoto', data: { itemKey } });
    } else {
      dispatch({ type: 'OPEN_MODAL', modal: 'detail', data: { itemKey } });
    }
  }

  return (
    <div className={styles.grid}>
      {domain.map((key) => {
        const photos  = photosByItem.get(key) ?? [];
        const primary = primaryByItem.get(key) ?? null;
        const visible = isCellVisible(key);

        return (
          <GridCell
            key={key}
            itemKey={key}
            label={formatLabel(activeHunt.type, key)}
            photos={photos}
            primaryPhoto={primary}
            isInHuntList={huntList.includes(key)}
            isShared={primary ? sharedLocations.has(primary.location) : false}
            layers={layers}
            onClick={() => handleCellClick(key)}
            style={visible ? undefined : { opacity: 0.2, pointerEvents: 'none' }}
          />
        );
      })}

      {isCustom && (
        <button
          className={styles.addItemTile}
          onClick={() => dispatch({ type: 'OPEN_MODAL', modal: 'addPhoto', data: { itemKey: null } })}
        >
          + Add Item
        </button>
      )}
    </div>
  );
}
